/* kz: keeps the dot indicators of mobile product-card swipe galleries in sync.
   One capturing scroll listener on document, so cards injected later
   (filters, sorting, pagination) work without re-initialising. */
(function () {
  if (window.kzCardSwipe) return;
  window.kzCardSwipe = true;

  var pending = [];
  var frame = null;

  function update(track) {
    var width = track.clientWidth;
    if (!width) return;
    var index = Math.round(Math.abs(track.scrollLeft) / width);
    var card = track.closest('.kz-card--swipe');
    if (!card) return;
    var dots = card.querySelectorAll('.kz-card-swipe__dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (!target || !target.classList || !target.classList.contains('kz-card-swipe__track')) return;
      if (pending.indexOf(target) === -1) pending.push(target);
      if (frame) return;
      frame = requestAnimationFrame(function () {
        pending.forEach(update);
        pending = [];
        frame = null;
      });
    },
    { capture: true, passive: true }
  );
})();
